const bookingContent = {
  bookBtn: 'AGENDA CITA',
  zero: 0
}

export default bookingContent
